import { Grid, Paper, Stack, Typography } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { CardAttributesProps } from './CardAttributes'

type OrderViewCardAttribute = CardAttributesProps & {
  sizeXs?: number
  sizeSm?: number
  sizeMd?: number
  sizeLg?: number
}

type OrderViewCard = {
  title?: string
  attributes?: OrderViewCardAttribute[]
}

export const SimpleCardWithAttributes = observer((props: OrderViewCard) => {
  const { title, attributes } = props

  return (
    <Paper variant='outlined' sx={{ p: '1rem' }}>
      <Grid container direction={'column'} spacing={2}>
        <Grid size={12}>
          <Stack>
            <Typography variant='subtitle1'>{title}</Typography>
          </Stack>
        </Grid>
        <Grid size={12}>
          <Grid container columnSpacing={4} rowSpacing={2}>
            {attributes?.map((attribute, index) => (
              <Grid
                key={index}
                size={{
                  xs: attribute.sizeXs,
                  sm: attribute.sizeSm || attribute.sizeXs,
                  md: attribute.sizeMd || attribute.sizeSm || attribute.sizeXs,
                  lg: attribute.sizeLg || attribute.sizeMd || attribute.sizeSm || attribute.sizeXs,
                }}
              >
                <Stack>
                  <Typography variant='body2'>{attribute.label}</Typography>
                  <Typography
                    sx={{ fontWeight: 'bold' }}
                    variant='body1'
                    data-cy={`${title}-${attribute.label}`.replace(/[\u200B-\u200D\uFEFF]/g, '')}
                  >
                    {attribute.value}
                  </Typography>
                </Stack>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  )
})
